/* eslint-disable curly */
import React, { Component, useEffect, useRef, useState } from "react";
import {
  View,
  Text,
  Dimensions,
  TextInput,
  TouchableOpacity,
  Keyboard,
  Animated,
  Platform,
  ScrollView,
  Switch,
  KeyboardAvoidingView,
  ImageBackground,
} from "react-native";
import { TextInputMask } from "react-native-masked-text";
import { StackActions, NavigationActions } from "react-navigation";
import { EventRegister } from "react-native-event-listeners";
import Icon from "react-native-vector-icons/FontAwesome";

import styles from "./styles";
import ButtonConfirm from "../../components/ButtonConfirm";
import Loading from "../../components/Loading";
import { getAluno, adicionarTelefone } from "../../services/aluno-service";
import { alert } from "../../utils/alerts";

const widthScreen = Dimensions.get("screen").width;
const widthInput = "90%";

const AdicionarCelular = ({ navigation }) => {
  const [numero, setNumero] = useState("");
  const [whatsapp, setWhatsapp] = useState("");
  const [loading, setLoading] = useState(false);
  const [confirmDisabled, setConfirmDisabled] = useState(true);
  const phoneField = useRef(null);
  const button = useRef(null);

  const handlerNumero = async (e) => {
    setNumero(e.trim());
  };

  useEffect(() => {
    if (!numero.trim().match(/^\([1-9]{2}\) (?:9[1-9])[0-9]{3}\-[0-9]{4}$/i)) {
      setConfirmDisabled(true);
    } else if (whatsapp !== "") {
      setConfirmDisabled(false);
    }
  }, [numero, whatsapp]);

  const enviar = async () => {
    setLoading(true);
    const unmaskedPhone = phoneField.current.getRawValue();

    const telefone = {
      numero: unmaskedPhone,
      whatsapp,
    };
    try {
      const response = await adicionarTelefone(telefone);

      if (!response.ok) {
        let { erro } = await response.json();
        setLoading(false);
        return alert("Ops...", erro);
      }

      let { telefoneId } = await response.json();

      Keyboard.dismiss();

      const { fromSemTelefone } = navigation.state ?? navigation.state.params;

      fromSemTelefone
        ? EventRegister.emit("SemTelefoneVerificado", "")
        : EventRegister.emit("reload", "");

      navigation.replace("VerificarCodigoSMS", { telefoneId, fromSemTelefone });
      setLoading(false);
    } catch (erro) {
      setLoading(false);
      console.log(erro);
      alert(
        "Ops...",
        "Houve um problema ao consultar, verifique o numero e tente novamente"
      );
    }
  };

  return (
    <>
      {loading && <Loading />}
      <KeyboardAvoidingView
        style={styles.container}
        behavior={Platform.select({
          ios: "padding",
          android: "null",
        })}
        keyboardVerticalOffset={Platform.select({ ios: 64, android: 0 })}
      >
        <ImageBackground
          source={require("../../../resources/imgs/bg.jpg")}
          style={styles.container}
          imageStyle={styles.imageContainer}
        >
          <View style={[styles.containerForm]}>
            <ScrollView style={{ flex: 1, width: "100%" }}>
              <Text style={styles.textHeader1}>
                Informe o número do seu celular
              </Text>
              <TextInputMask
                type="cel-phone"
                value={numero}
                ref={phoneField}
                style={[styles.input]}
                editable={!loading}
                placeholder="(99) 99999-9999"
                keyboardType="phone-pad"
                autoCompleteType="tel"
                autoCapitalize="none"
                textContentType="telephoneNumber"
                autoFocus={true}
                placeholderTextColor="#CCC"
                onChangeText={handlerNumero}
                onSubmitEditing={enviar}
              />

              <View
                style={[
                  styles.containerRow,
                  { alignItems: "center", justifyContent: "center" },
                ]}
              >
                <TouchableOpacity
                  style={{ alignItems: "center" }}
                  onPress={() => {
                    setWhatsapp(whatsapp === "" ? true : !whatsapp);
                  }}
                >
                  <Text style={styles.label}>Tem Whatsapp nesse número?</Text>
                  <View style={{ flexDirection: "row", alignItems: "center" }}>
                    <Icon
                      name={"whatsapp"}
                      size={45}
                      color={
                        whatsapp === "" ? "#A33" : whatsapp ? "#0A0" : "#A55"
                      }
                      style={{ marginTop: 10 }}
                    />
                    <Text
                      style={{
                        fontFamily: "Montserrat-Medium",
                        marginLeft: 5,
                        fontSize: 20,
                        marginTop: 10,
                        color: "#FFF",
                      }}
                    >
                      {whatsapp === "" ? "" : whatsapp ? "Sim" : "Não"}
                    </Text>
                  </View>
                </TouchableOpacity>
              </View>
              <Text style={styles.textHeader2}>
                Enviaremos um SMS com o código de validação.
              </Text>
            </ScrollView>
            <ButtonConfirm
              text={loading ? "Enviando..." : "Enviar"}
              disabled={confirmDisabled}
              onPress={enviar}
              msgDisabled={
                !numero
                  .trim()
                  .match(/^\([1-9]{2}\) (?:9[1-9])[0-9]{3}\-[0-9]{4}$/i)
                  ? "Preencha um telefone válido"
                  : "Informe se tem whatsapp"
              }
            />
          </View>
        </ImageBackground>
      </KeyboardAvoidingView>
    </>
  );
};

AdicionarCelular.navigationOptions = ({ navigation }) => {
  return {
    headerStyle: {
      backgroundColor: "#0F0F0F",
    },
    headerTitleStyle: {
      color: "#FFF",
    },
    headerLeft: () => (
      <TouchableOpacity
        onPress={() => {
          const navigateAction = StackActions.pop(1);
          navigation.dispatch(navigateAction);
        }}
      >
        <Icon
          style={styles.iconToggle}
          name="arrow-left"
          size={20}
          color="#F1F1F1"
        />
      </TouchableOpacity>
    ),
  };
};

export default AdicionarCelular;
